import * as React from "react";
function SvgNoimageSquare1(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 360 360" {...props}><path fill="#7b7b7b" d="M0 0h360v360H0z" /><text transform="translate(68 200)" fill="#fff" fontSize={48} fontFamily="NotoSansCJKjp-Regular,Noto Sans CJK JP"><tspan x={0} y={0}>{"NO IMAGE"}</tspan></text></svg>;
}
export default SvgNoimageSquare1;